/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContactMessage } from '../models/ContactMessage';
import type { ConversationListResponse } from '../models/ConversationListResponse';
import type { ConversationMessages } from '../models/ConversationMessages';
import type { CounterpartyResponse } from '../models/CounterpartyResponse';
import type { NewMessage } from '../models/NewMessage';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MessagesService {
    /**
     * Get Counterparty
     * @param userId
     * @returns CounterpartyResponse Successful Response
     * @throws ApiError
     */
    public static getCounterpartyApiMessagesCounterpartyUserIdGet(
        userId: string,
    ): CancelablePromise<CounterpartyResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/messages/counterparty/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                404: `Not Found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Conversations
     * @param cursor
     * @returns ConversationListResponse Successful Response
     * @throws ApiError
     */
    public static listConversationsApiMessagesConversationsGet(
        cursor?: (string | null),
    ): CancelablePromise<ConversationListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/messages/conversations',
            query: {
                'cursor': cursor,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Messages
     * @param userId
     * @param cursor
     * @returns ConversationMessages Successful Response
     * @throws ApiError
     */
    public static listMessagesApiMessagesUserIdGet(
        userId: string,
        cursor?: (string | null),
    ): CancelablePromise<ConversationMessages> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/messages/{user_id}',
            path: {
                'user_id': userId,
            },
            query: {
                'cursor': cursor,
            },
            errors: {
                404: `Not Found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Send Message
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    public static sendMessageApiMessagesNewPost(
        requestBody: NewMessage,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/messages/new',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Share Contact
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    public static shareContactApiMessagesShareContactPost(
        requestBody: ContactMessage,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/messages/share-contact',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Read Message
     * @param messageId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static readMessageApiMessagesReadMessageMessageIdPost(
        messageId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/messages/read-message/{message_id}',
            path: {
                'message_id': messageId,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Message
     * @param messageId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteMessageApiMessagesMessageMessageIdDelete(
        messageId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/messages/message/{message_id}',
            path: {
                'message_id': messageId,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Conversation
     * @param userId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteConversationApiMessagesConversationUserIdDelete(
        userId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/messages/conversation/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                422: `Validation Error`,
            },
        });
    }
}
